import React, { useMemo } from 'react';
import styles from './index.module.less';
import { useRouter } from 'next/router';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import classNames from 'classnames';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import { ArticleButtonModel } from '@/types/home';

const BottomFlexButton: React.FC<{ model?: ArticleButtonModel }> = ({ model }) => {
  const router = useRouter();
  const { width } = useScreenSize();

  const onAddAccountClick = () => {
    if (model?.func_button_path?.length > 0) {
      if (model?.func_button_is_inner) {
        router.push(model?.func_button_path ?? '');
      } else {
        window.open(model?.func_button_path ?? '', '_blank');
      }
    }
  };

  const showContent = useMemo(() => {
    if (model) {
      const backgroundColor =
        model?.background_color_type === 'solid'
          ? model?.background_color
          : `linear-gradient(to right, ${model?.background_gradient_start}, ${model?.background_gradient_end})`;

      return (
        <button
          className={classNames([styles.buttonContent])}
          style={{ color: model?.font_color, background: backgroundColor }}
          onClick={() => {
            ga_logEvent(EventName.Blog_Detail_Bottom_AddAccount_Btn);
            model?.label && ga_logEvent(model?.label);
            onAddAccountClick();
          }}
        >
          <span>{model?.label ?? ''}</span>
        </button>
      );
    } else {
      return null;
    }
  }, [model, width]);

  return <>{showContent}</>;
};

export default BottomFlexButton;
